// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-logo {
  text-align: center;
}

.game-footer-col {
  width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0 !important;
  min-height: 4.0625rem;
  border-top: 1px solid rgba(239, 239, 239, 0.25);
}
@media screen and (max-width: 991.99px) {
  .game-footer-col {
    margin-top: 1rem;
  }
}
@media screen and (max-width: 1199.98px) and (max-height: 500px) {
  .game-footer-col {
    display: flex !important;
    padding: 0px 1rem !important;
  }
}
.game-footer-col .footer-fairness-label {
  color: #EFEFEF;
  font-size: 0.75rem;
}
.game-footer-col .soundSetting {
  background-color: var(--primary-95);
  padding: 10px;
  position: absolute;
  top: -60px;
  left: auto;
  right: 0;
}
.game-footer-col .soundSetting p {
  color: var(--white);
}
@media screen and (max-width: 767.99px) {
  .game-footer-col ul li svg {
    width: 1rem;
  }
}

@media screen and (max-width: 767.98px) {
  .rc-tooltip {
    display: none !important;
  }
  .footer-logo {
    text-align: center;
  }
  .footer-logo img {
    width: 50%;
  }
}
.rc-tooltip-placement-top .rc-tooltip-arrow,
.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  margin-left: 0 !important;
  border-top-color: #fff;
}

.rc-tooltip-inner {
  border-color: #fff;
}

.dice-game-setting-footer {
  background-color: var(--gameBg);
  margin-top: 0.5rem;
  border-radius: 10px;
  padding: 0 8px;
}
.dice-game-setting-footer .dice-footer-logo {
  height: 63px;
  width: auto;
  min-width: 30px;
  opacity: 0.2;
}
.dice-game-setting-footer .dice-setting-list .list-inline-item {
  cursor: pointer;
}
.dice-game-setting-footer .dice-setting-list .list-inline-item:hover .dice-footer-setting-icons, .dice-game-setting-footer .dice-setting-list .list-inline-item:active .dice-footer-setting-icons {
  opacity: 0.8;
  transform: scale(0.95);
}
.dice-game-setting-footer .dice-setting-list .list-inline-item img {
  width: 20px;
}
.dice-game-setting-footer .setting-dropdown-group .dropdown-item.active,
.dice-game-setting-footer .setting-dropdown-group .dropdown-item:active {
  color: var(--activeBlue);
  text-decoration: none;
  background-color: transparent;
}
.dice-game-setting-footer .setting-dropdown-group .dropdown-item.active img,
.dice-game-setting-footer .setting-dropdown-group .dropdown-item:active img {
  filter: brightness(0) saturate(100%) invert(29%) sepia(100%) saturate(696%) hue-rotate(159deg) brightness(100%) contrast(102%);
}
.dice-game-setting-footer .setting-btn-toggle {
  position: relative;
}
.dice-game-setting-footer .setting-btn-toggle[aria-expanded=true]::after {
  content: "";
  position: absolute;
  bottom: 41px;
  left: 60%;
  margin-left: -10px;
  display: block;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid var(--white);
}
.dice-game-setting-footer .stats-dropdown-group .dropdown-menu {
  width: 0;
  background-color: transparent;
}
.dice-game-setting-footer .stats-dropdown-group .dropdown-menu .card {
  width: 280px;
  background-color: var(--darkSlate);
  border-radius: 10px;
  overflow: hidden;
}
.dice-game-setting-footer .stats-dropdown-group .dropdown-menu .card .card-header {
  cursor: move;
}
.dice-game-setting-footer .stats-dropdown-group .dropdown-menu .card .card-header img:hover {
  opacity: 0.8;
}
.dice-game-setting-footer .stats-dropdown-group .dropdown-menu .card-header {
  background-color: var(--primaryDark);
}
.dice-game-setting-footer .dropdown-menu img {
  width: 20px;
}
.dice-game-setting-footer .volume-bar {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  background: var(--aquaBlue);
  border-radius: 50em;
  outline: none;
  transition: opacity 0.2s;
}
.dice-game-setting-footer .volume-bar::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50em;
  background: var(--darkBlue);
  cursor: pointer;
}
.dice-game-setting-footer .volume-bar::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50em;
  background: var(--darkBlue);
  cursor: pointer;
}

.list-inline .list-inline-item {
  cursor: pointer;
}
.list-inline .list-inline-item:not(:last-child) {
  margin-right: 1.25rem;
}
@media screen and (max-width: 767.98px) {
  .list-inline .list-inline-item:not(:last-child) {
    margin-right: 0.5rem;
  }
}
.list-inline .list-inline-item.active svg {
  fill: #fff;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu {
  width: 227px;
  bottom: calc(100% + 12px);
  right: 0;
  background-color: transparent;
  height: 1px;
}
@media screen and (max-width: 767.98px) {
  .list-inline .list-inline-item.live-stats-wrapper .dropdown-menu {
    bottom: auto;
    top: calc(100% + 12px);
  }
}
@media screen and (max-width: 440.98px) {
  .list-inline .list-inline-item.live-stats-wrapper .dropdown-menu {
    right: -2.75rem;
  }
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu {
  background-color: var(--primary-95);
  border: 1px solid var(--primary-95);
  color: var(--white);
  border-radius: 0.25rem;
  position: absolute;
  bottom: 100%;
  width: 320px;
  left: 63%;
}
@media screen and (max-width: 767.98px) {
  .list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu {
    bottom: 0;
  }
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-head {
  padding: 0.5rem;
  cursor: move;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-head h6 {
  font-size: 14px;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-head .live-stats-refresh-icon {
  margin-right: 0.75rem;
  cursor: pointer;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-head .live-stats-close-icon {
  cursor: pointer;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-body {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  background-color: var(--TabBgActive) !important;
  padding: 2px;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-body .live-stats-cards {
  background-color: var(--primary-95);
  border-radius: 5px;
  padding: 0.675rem;
  font-size: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex-basis: 48%;
  flex-grow: 1;
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-body .live-stats-cards .stats-result-text {
  color: var(--dice-green-main);
}
.list-inline .list-inline-item.live-stats-wrapper .dropdown-menu .live-stats-dropdown-menu .live-stats-content-body .live-stats-cards .stats-result-loss-text {
  color: #F1313E;
}

.text-button {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
}
@media screen and (max-width: 767.99px) {
  .text-button {
    font-size: 12px;
  }
}

.apexcharts-canvas {
  background: var(--primary-95);
}

.apexcharts-tooltip {
  background: #f3f3f3;
  color: #000000;
}

.apexcharts-toolbar {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/GameFooter/gamefooter.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAMA;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,+CAAA;AAHF;AASE;EAXF;IAYI,gBAAA;EANF;AACF;AAQE;EAfF;IAgBI,wBAAA;IAEA,4BAAA;EANF;AACF;AAQE;EACE,cAAA;EACA,kBAAA;AANJ;AASE;EACE,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AAcQ;EADF;IAEI,WAAA;EAXR;AACF;;AAiBA;EACE;IACE,wBAAA;EAdF;EAiBA;IACE,kBAAA;EAfF;EAiBE;IACE,UAAA;EAfJ;AACF;AAmBA;;;EAGE,yBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAjBF;AAmBE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAjBJ;AAqBI;EACE,eAAA;AAnBN;AAqBM;EAEE,YAAA;EACA,sBAAA;AApBR;AAuBM;EACE,WAAA;AArBR;AA4BI;;EAEE,wBAAA;EACA,qBAAA;EACA,6BAAA;AA1BN;AA4BM;;EACE,8HAAA;AAzBR;AA8BE;EACE,kBAAA;AA5BJ;AA+BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,oCAAA;EACA,mCAAA;AA7BR;AAmCI;EACE,QAAA;EACA,6BAAA;AAjCN;AAmCM;EACE,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;AAjCR;AAmCQ;EACE,YAAA;AAjCV;AAoCY;EACE,YAAA;AAlCd;AAwCM;EACE,oCAAA;AAtCR;AA4CI;EACE,WAAA;AA1CN;AA8CE;EACE,wBAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EAEA,wBAAA;AA5CJ;AA8CI;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AA5CN;AA+CI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AA7CN;;AAqDE;EACE,eAAA;AAlDJ;AAoDI;EACE,qBAAA;AAlDN;AAoDM;EAHF;IAII,oBAAA;EAjDN;AACF;AAqDM;EACE,UAAA;AAnDR;AAwDM;EACE,YAAA;EACA,yBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;AAtDR;AAwDQ;EAPF;IAQI,YAAA;IACA,sBAAA;EArDR;AACF;AAuDQ;EAZF;IAaI,eAAA;EApDR;AACF;AAsDQ;EACE,mCAAA;EACA,mCAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AApDV;AAsDU;EAVF;IAWI,SAAA;EAnDV;AACF;AAqDU;EACE,eAAA;EACA,YAAA;AAnDZ;AAqDY;EACE,eAAA;AAnDd;AAsDY;EACE,qBAAA;EACA,eAAA;AApDd;AAuDY;EACE,eAAA;AArDd;AAyDU;EACE,UAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,+CAAA;EACA,YAAA;AAvDZ;AAyDY;EACE,mCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAvDd;AAyDc;EACE,6BAAA;AAvDhB;AA0Dc;EACE,cAAA;AAxDhB;;AAmEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAhEF;AAkEE;EALF;IAMI,eAAA;EA/DF;AACF;;AAkEA;EACE,6BAAA;AA/DF;;AAkEA;EACE,mBAAA;EACA,cAAA;AA/DF;;AAkEA;EACE,wBAAA;AA/DF","sourcesContent":[".footer-logo {\n  text-align: center;\n\n  // img {\n  //   width: 60%;\n  // }\n}\n\n.game-footer-col {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0 !important;\n  min-height: 4.0625rem;\n  border-top: 1px solid rgba(239, 239, 239, 0.25);\n\n  // @media screen and (max-width: 767.98px) {\n  //   display: none !important;\n  // }\n\n  @media screen and (max-width: 991.99px) {\n    margin-top: 1rem;\n  }\n\n  @media screen and (max-width:1199.98px) and (max-height: 500px) {\n    display: flex !important;\n    // margin-top: 1rem !important;\n    padding: 0px 1rem !important;\n  }\n\n  .footer-fairness-label {\n    color: #EFEFEF;\n    font-size: 0.75rem;\n  }\n\n  .soundSetting {\n    background-color: var(--primary-95);\n    padding: 10px;\n    position: absolute;\n    top: -60px;\n    left: auto;\n    right: 0;\n\n    p {\n      color: var(--white);\n    }\n  }\n\n  ul {\n    li {\n      svg {\n        @media screen and (max-width: 767.99px) {\n          width: 1rem;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767.98px) {\n  .rc-tooltip {\n    display: none !important;\n  }\n\n  .footer-logo {\n    text-align: center;\n\n    img {\n      width: 50%;\n    }\n  }\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  margin-left: 0 !important;\n  border-top-color: #fff;\n}\n\n.rc-tooltip-inner {\n  border-color: #fff;\n}\n\n.dice-game-setting-footer {\n  background-color: var(--gameBg);\n  margin-top: 0.5rem;\n  border-radius: 10px;\n  padding: 0 8px;\n\n  .dice-footer-logo {\n    height: 63px;\n    width: auto;\n    min-width: 30px;\n    opacity: 0.2;\n  }\n\n  .dice-setting-list {\n    .list-inline-item {\n      cursor: pointer;\n\n      &:hover .dice-footer-setting-icons,\n      &:active .dice-footer-setting-icons {\n        opacity: 0.8;\n        transform: scale(0.95);\n      }\n\n      img {\n        width: 20px;\n      }\n    }\n  }\n\n  .setting-dropdown-group {\n\n    .dropdown-item.active,\n    .dropdown-item:active {\n      color: var(--activeBlue);\n      text-decoration: none;\n      background-color: transparent;\n\n      img {\n        filter: brightness(0) saturate(100%) invert(29%) sepia(100%) saturate(696%) hue-rotate(159deg) brightness(100%) contrast(102%);\n      }\n    }\n  }\n\n  .setting-btn-toggle {\n    position: relative;\n\n    &[aria-expanded=\"true\"] {\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 41px;\n        left: 60%;\n        margin-left: -10px;\n        display: block;\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-top: 10px solid var(--white);\n      }\n    }\n  }\n\n  .stats-dropdown-group {\n    .dropdown-menu {\n      width: 0;\n      background-color: transparent;\n\n      .card {\n        width: 280px;\n        background-color: var(--darkSlate);\n        border-radius: 10px;\n        overflow: hidden;\n\n        .card-header {\n          cursor: move;\n\n          img {\n            &:hover {\n              opacity: 0.8;\n            }\n          }\n        }\n      }\n\n      .card-header {\n        background-color: var(--primaryDark);\n      }\n    }\n  }\n\n  .dropdown-menu {\n    img {\n      width: 20px;\n    }\n  }\n\n  .volume-bar {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 8px;\n    background: var(--aquaBlue);\n    border-radius: 50em;\n    outline: none;\n    -webkit-transition: .2s;\n    transition: opacity .2s;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 16px;\n      height: 16px;\n      border-radius: 50em;\n      background: var(--darkBlue);\n      cursor: pointer;\n    }\n\n    &::-moz-range-thumb {\n      width: 16px;\n      height: 16px;\n      border-radius: 50em;\n      background: var(--darkBlue);\n      cursor: pointer;\n    }\n  }\n}\n\n\n// Live start drag over css start here\n.list-inline {\n  .list-inline-item {\n    cursor: pointer;\n\n    &:not(:last-child) {\n      margin-right: 1.25rem;\n\n      @media screen and (max-width: 767.98px) {\n        margin-right: 0.5rem;\n      }\n    }\n\n    &.active {\n      svg {\n        fill: #fff;\n      }\n    }\n\n    &.live-stats-wrapper {\n      .dropdown-menu {\n        width: 227px;\n        bottom: calc(100% + 12px);\n        right: 0;\n        background-color: transparent;\n        height: 1px;\n\n        @media screen and (max-width: 767.98px) {\n          bottom: auto;\n          top: calc(100% + 12px);\n        }\n\n        @media screen and (max-width: 440.98px) {\n          right: -2.75rem;\n        }\n\n        .live-stats-dropdown-menu {\n          background-color: var(--primary-95);\n          border: 1px solid var(--primary-95);\n          color: var(--white);\n          border-radius: 0.25rem;\n          position: absolute;\n          bottom: 100%;\n          width: 320px;\n          left: 63%;\n\n          @media screen and (max-width: 767.98px) {\n            bottom: 0;\n          }\n\n          .live-stats-content-head {\n            padding: 0.5rem;\n            cursor: move;\n\n            h6 {\n              font-size: 14px;\n            }\n\n            .live-stats-refresh-icon {\n              margin-right: 0.75rem;\n              cursor: pointer;\n            }\n\n            .live-stats-close-icon {\n              cursor: pointer;\n            }\n          }\n\n          .live-stats-content-body {\n            padding: 0;\n            display: flex;\n            flex-wrap: wrap;\n            gap: 2px;\n            background-color: var(--TabBgActive) !important;\n            padding: 2px;\n\n            .live-stats-cards {\n              background-color: var(--primary-95);\n              border-radius: 5px;\n              padding: .675rem;\n              font-size: .75rem;\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              flex-direction: column;\n              flex-basis: 48%;\n              flex-grow: 1;\n\n              .stats-result-text {\n                color: var(--dice-green-main);\n              }\n\n              .stats-result-loss-text {\n                color: #F1313E;\n              }\n            }\n          }\n        }\n\n      }\n    }\n  }\n}\n\n.text-button {\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 400;\n\n  @media screen and (max-width: 767.99px) {\n    font-size: 12px;\n  }\n}\n\n.apexcharts-canvas {\n  background: var(--primary-95);\n}\n\n.apexcharts-tooltip {\n  background: #f3f3f3;\n  color: #000000;\n}\n\n.apexcharts-toolbar {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
